module.exports = __webpack_public_path__ + "static/media/4-Diamond.ae90a39e.svg";